import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";

export default function DashboardPanel({
  title,
  description,
  children,
  className = "",
  contentClassName = "",
  testid,
}) {
  return (
    <Card className={`min-w-0 overflow-hidden rounded-lg ${className}`} data-testid={testid}>
      <CardHeader className="border-b border-border p-4 sm:p-5">
        <CardTitle className="break-words text-base text-foreground">{title}</CardTitle>
        {description ? <CardDescription>{description}</CardDescription> : null}
      </CardHeader>
      <CardContent className={`min-w-0 p-4 sm:p-5 ${contentClassName}`}>
        {children}
      </CardContent>
    </Card>
  );
}
